import A from 'components/atoms/A/A';
import Button from 'components/atoms/Button/Button';
import Heading from 'components/atoms/Heading/Heading';
import Modal from 'components/atoms/Modal/Modal';
import Txt from 'components/atoms/Txt/Txt';
import PaypalLogo from 'components/molecules/PaypalRequiredModal/assets/paypal-logo-narrow.svg';
import classes from 'components/molecules/PaypalRequiredModal/PaypalRequiredModal.module.scss';
import React from 'react';

export type Props = {
  onClose: () => void;
  linkAccountUrl?: string;
};

export default function PaypalRequiredModal({
  onClose,
  linkAccountUrl,
}: Props): React.ReactElement {
  return (
    <Modal
      onClose={onClose}
      buttons={
        <>
          {linkAccountUrl && (
            <Button
              buttonType="primary"
              className={classes.linkButton}
              onClick={() => window.open(linkAccountUrl, '_blank', 'noopener,noreferrer')}
            >
              Link Paypal Account
            </Button>
          )}
          <Button onClick={onClose} buttonType="text">
            Close and link later
          </Button>
        </>
      }
      className={classes.modal}
      bodyClassName={classes.modalBody}
      buttonsClassName={classes.buttons}
    >
      <PaypalLogo width={34} height={39} />
      <Heading level={2} className={classes.heading}>
        Paypal Required
      </Heading>
      <Txt component="p">
        We need you to link your PayPal account because we can then be sure that we are sending the
        rewards to the correct account.
      </Txt>
      <Txt component="p">
        It is completely secure, and all we need you to share is your email and address -{' '}
        <Txt component="b" skipTranslation>
          we do not get access to your account. Please ensure that the account you have linked is
          verified by PayPal.
        </Txt>{' '}
        To ensure your PayPal account remains up to date, you may be asked to refresh your linked
        PayPal again in the future.
      </Txt>
      <Txt component="p">
        Your rewards will usually arrive in your PayPal account within an hour. This can take longer
        at PayPal&#39;s busy times, so don&#39;t panic if you don&#39;t see your cash out straight
        away.
      </Txt>
      <Txt component="p">
        If you have any issues doing this, please contact our{' '}
        <A href="https://mobiworkx.zendesk.com/hc/en-us/sections/360002470099-Rewards">
          Help Center
        </A>
        .
      </Txt>
    </Modal>
  );
}
